import { PageContainer, type PageContainerProps } from '@ant-design/pro-components'
import { cn } from '@/utils/index.ts'

/** 路由表单统一限制标题、内容和导航的整体宽度，保留窄屏自适应。 */
export function FormPageContainer({ className, ...props }: PageContainerProps) {
  return <PageContainer {...props} className={cn('mx-auto w-full max-w-[90rem] min-w-0', className)} />
}
